import * as React from 'react'

import { Alert, Box, Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import InputText from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { FactorialIDApiError, deprovisionTotp } from 'modules/factorial_id/lib/api_client'

class DeprovisionMFAForm extends Form {
  constructor(values: { password: string }) {
    super(values, {
      password: 'string',
    })
  }
}

interface DeprovisionMFAModalProps {
  onClose: () => void
  onSuccess: () => void
}

export function DeprovisionMFAModal({ onClose, onSuccess }: DeprovisionMFAModalProps) {
  const deprovisionForm = React.useRef(
    new DeprovisionMFAForm({
      password: '',
    })
  ).current
  const passwordField = deprovisionForm.get('password')

  const [error, setError] = React.useState<string | null>(null)
  const [submitting, setSubmitting] = React.useState(false)

  const onSubmit = async () => {
    const password = deprovisionForm.get('password').value

    if (!password) return

    try {
      setSubmitting(true)
      setError(null)

      await deprovisionTotp(password)

      app.setFlash({
        type: 'correct',
        message: i18n.t('personal_settings.mfa.deactivated_successfully'),
      })

      onSuccess()
    } catch (err) {
      if (err instanceof FactorialIDApiError) {
        if (err.code == 'invalid_credentials') {
          setError(i18n.t('personal_settings.mfa.deactivate_invalid_credentials'))
        } else {
          setError(err.message || 'An unexpected error occurred')
        }
      } else {
        setError(err instanceof Error ? err.message : 'Failed to disable MFA')
      }
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal
      illustration="lock-user"
      onClose={onClose}
      onSubmit={onSubmit}
      title={i18n.t('personal_settings.mfa.deactivate_modal_title')}
      description={i18n.t('personal_settings.mfa.deactivate_instructions')}
      footer={
        <>
          <Button type="secondary" disabled={submitting} onClick={onClose}>
            {i18n.t('personal_settings.mfa.cancel')}
          </Button>
          <Button disabled={submitting} type="negative" submit>
            {i18n.t('personal_settings.mfa.deactivate')}
          </Button>
        </>
      }
    >
      {error && <Alert color="error">{error}</Alert>}

      <Box paddingTop="s12">
        <InputText type="password" label={i18n.t('common.password')} field={passwordField} />
      </Box>
    </Modal>
  )
}
